import * as React from 'react';
import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={51} height={10} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <mask
      id="mask0_5456_75354"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="51"
      height="10"
    >
      <path
        d="M8.36744 0.833984H5.0026C3.99581 0.833984 3.07252 1.19077 2.35229 1.78574C1.42616 2.54961 0.835938 3.70634 0.835938 5.00065C0.835938 6.00745 1.19272 6.93074 1.78769 7.65096C1.95755 7.85687 2.14638 8.04571 2.35229 8.21556C3.07252 8.80958 3.99581 9.16732 5.0026 9.16732C6.29692 9.16732 7.45364 8.5771 8.21751 7.65096C8.81153 6.93074 9.16927 6.00745 9.16927 5.00065V1.63581C9.16927 1.19267 8.81058 0.833984 8.36649 0.833984H8.36744ZM7.58079 5.00065C7.58079 5.62693 7.35875 6.20197 6.98867 6.65081C6.51327 7.22775 5.79305 7.59497 4.98742 7.59497C4.36114 7.59497 3.7861 7.37293 3.33726 7.00285C3.20916 6.89752 3.09149 6.77891 2.98522 6.65081C2.61514 6.20197 2.3931 5.62788 2.3931 5.00065C2.3931 4.19503 2.76033 3.4748 3.33726 2.9994C3.7861 2.62932 4.36019 2.40728 4.98742 2.40728C6.41933 2.40728 7.58079 3.56875 7.58079 5.00065Z"
        fill="url(#paint0_linear_5456_75354)"
      />
      <path
        d="M11.0206 8V2.4H13.1486C13.6019 2.4 13.9779 2.47733 14.2766 2.632C14.5752 2.78667 14.7966 2.99733 14.9406 3.264C15.0899 3.52533 15.1646 3.824 15.1646 4.16C15.1646 4.46933 15.0926 4.75733 14.9486 5.024C14.8099 5.28533 14.5912 5.49867 14.2926 5.664C13.9939 5.82933 13.6126 5.912 13.1486 5.912H12.1406V8H11.0206ZM12.1406 5.008H13.0766C13.4126 5.008 13.6526 4.93067 13.7966 4.776C13.9459 4.62133 14.0206 4.416 14.0206 4.16C14.0206 3.89333 13.9459 3.68533 13.7966 3.536C13.6526 3.38667 13.4126 3.312 13.0766 3.312H12.1406V5.008ZM15.9659 8V2.4H17.0859V7.128H19.5339V8H15.9659ZM20.0901 8L22.1301 2.4H23.4021L25.4421 8H24.2581L22.7621 3.672L21.2581 8H20.0901ZM20.9861 6.744L21.2821 5.872H24.1621L24.4501 6.744H20.9861ZM26.8793 8V3.304H25.2473V2.4H29.6233V3.304H27.9913V8H26.8793ZM30.3799 8V2.4H31.4999V8H30.3799ZM32.5909 8V2.4H33.7109L36.2469 6.2V2.4H37.3669V8H36.2469L33.7109 4.208V8H32.5909ZM40.6421 8.096C40.2261 8.096 39.8501 8.01333 39.5141 7.848C39.1781 7.68267 38.9087 7.43467 38.7061 7.104C38.5087 6.768 38.4101 6.344 38.4101 5.832V2.4H39.5301V5.84C39.5301 6.112 39.5754 6.33867 39.6661 6.52C39.7567 6.70133 39.8847 6.84 40.0501 6.936C40.2207 7.02667 40.4261 7.072 40.6661 7.072C40.9061 7.072 41.1087 7.02667 41.2741 6.936C41.4447 6.84 41.5754 6.70133 41.6661 6.52C41.7567 6.33867 41.8021 6.112 41.8021 5.84V2.4H42.9221V5.832C42.9221 6.344 42.8181 6.768 42.6101 7.104C42.4074 7.43467 42.1327 7.68267 41.7861 7.848C41.4394 8.01333 41.0581 8.096 40.6421 8.096ZM43.9503 8V2.4H45.2943L46.9823 5.848L48.6463 2.4H49.9823V8H48.8623V4.296L47.4143 7.216H46.5263L45.0703 4.296V8H43.9503Z"
        fill="url(#paint1_linear_5456_75354)"
      />
    </mask>
    <g mask="url(#mask0_5456_75354)">
      <rect y="-5" width="51" height="19" fill="url(#paint2_linear_5456_75354)" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5456_75354"
        x1="0.857292"
        y1="0.899902"
        x2="9.90819"
        y2="1.77013"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#22CFAB" />
        <stop offset="0.933931" stopColor="#0057A7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5456_75354"
        x1="10.1051"
        y1="0.0791015"
        x2="49.0025"
        y2="15.4127"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#22CFAB" />
        <stop offset="0.933931" stopColor="#0057A7" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5456_75354"
        x1="0.130689"
        y1="-4.84971"
        x2="52.5432"
        y2="8.67701"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#22CFAB" />
        <stop offset="0.933931" stopColor="#0057A7" />
      </linearGradient>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const IconPlatinum = memo(ForwardRef);
export default IconPlatinum;
